import { render, staticRenderFns } from "./UyapBagliDegilView.vue?vue&type=template&id=f2bc5080&scoped=true"
import script from "./UyapBagliDegilView.vue?vue&type=script&lang=ts"
export * from "./UyapBagliDegilView.vue?vue&type=script&lang=ts"
import style0 from "./UyapBagliDegilView.vue?vue&type=style&index=0&id=f2bc5080&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2bc5080",
  null
  
)

export default component.exports